module.exports = __webpack_public_path__ + "img/pi_xrpl2.d9815bb.png";